import ApiBase from '@/api/api-base'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class CrmTicket extends ApiBase {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/crm/ticket`)
  }

  open(id, showProgress) {
    return this._request({
      action: `${id}/open`,
      method: 'PATCH',
      showProgress
    })
  }

  close(id, showProgress) {
    return this._request({
      action: `${id}/close`,
      method: 'PATCH',
      showProgress
    })
  }
}
